<div class="row">
    <div class="col-md-7">
        <h2>Upcoming Pickup Schedule</h2>
        <h4>Click a Pickup Appointment to see details or edit.</h4>
    </div>
</div>
<div>
    <mt-dynamic-search-filters [config]="dynamicSearchFiltersConfig" (searchValuesUpdated)="search($event)"></mt-dynamic-search-filters>
    <mt-search-filter-daterange
        *ngIf="datepickerEntityName"
        [entity]="datepickerEntityName"
        [startDate]="startDate"
        [endDate]="endDate"
        (selectionChanged)="dateSelectionChanged($event)"
    ></mt-search-filter-daterange>
    <button (click)="clear()" class="btn btn-success">Clear</button>
</div>
<br />
<div class="table-responsive">
    <table class="table table-hover">
        <thead>
            <tr>
                <th>
                    Pickup Number
                    <span>
                        <i
                            [style.opacity]="getOpacity('PickupNumber', 'asc')"
                            (click)="orderBy($event, 'PickupNumber', 'asc')"
                            class="fa fa-sort-asc"
                        ></i>
                        <i
                            [style.opacity]="getOpacity('PickupNumber', 'desc')"
                            (click)="orderBy($event, 'PickupNumber', 'desc')"
                            class="fa fa-sort-desc"
                        ></i>
                    </span>
                </th>
                <th>Status</th>
                <th>
                    Desired Pickup Date
                    <span>
                        <i
                            [style.opacity]="getOpacity('DateRequested', 'asc')"
                            (click)="orderBy($event, 'DateRequested', 'asc')"
                            class="fa fa-sort-asc"
                        ></i>
                        <i
                            [style.opacity]="getOpacity('DateRequested', 'desc')"
                            (click)="orderBy($event, 'DateRequested', 'desc')"
                            class="fa fa-sort-desc"
                        >
                        </i>
                    </span>
                </th>
                <th>
                    Confirmed Pickup Date
                    <span>
                        <i
                            [style.opacity]="getOpacity('DateConfirmed', 'asc')"
                            (click)="orderBy($event, 'DateConfirmed', 'asc')"
                            class="fa fa-sort-asc"
                        ></i>
                        <i
                            [style.opacity]="getOpacity('DateConfirmed', 'desc')"
                            (click)="orderBy($event, 'DateConfirmed', 'desc')"
                            class="fa fa-sort-desc"
                        ></i>
                    </span>
                </th>
                <th *ngIf="isAdminUser || isCarrierUser">Driver</th>
                <th *ngIf="isAdminUser || isCustomerUser">Trucking Company</th>
                <th>Total Pallet Count</th>
                <th>Total Order Weight</th>
                <th>Security Gate Fee</th>
                <th>Prepaid Amount</th>
                <th>Pickup Balance</th>
                <th class="actions-header">Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let pickup of pickups">
                <tr class="no-pointer pickup-row">
                    <td class="ellipsis">
                        {{ pickup.PickupNumber }}
                    </td>
                    <td class="ellipsis">
                        {{ getStatusName(pickup.StatusId) }}
                    </td>
                    <td class="ellipsis">
                        {{ formatDateRequested(pickup) }}
                    </td>
                    <td class="ellipsis">
                        {{ pickup.DateConfirmed | date: 'medium' }}
                    </td>
                    <td *ngIf="isAdminUser || isCarrierUser" class="ellipsis">
                        <span *ngIf="pickup?.Driver?.Id > 0">
                            {{ pickup.Driver.FirstName }} {{ pickup.Driver.LastName }} - {{ pickup.Driver.Phone | phoneFormat }}
                        </span>
                    </td>
                    <td *ngIf="isAdminUser || isCustomerUser" class="ellipsis">
                        <span *ngIf="pickup.CarrierId > 0">
                            {{ pickup.Carrier?.Name }}
                        </span>
                        <span *ngIf="isAdminUser && pickup.CarrierId <= 0">
                            <mt-type-ahead
                                #carrierTypeaheadControl
                                [items]="carriers"
                                [maxToShow]="maxToShow"
                                (selectionChanged)="onCarrierSelected($event, pickup)"
                            >
                            </mt-type-ahead>
                        </span>
                    </td>
                    <td>
                        {{ totalPalletCount(pickup) }}
                    </td>
                    <td>
                        {{ totalOrderWeight(pickup) }}
                    </td>
                    <td class="ellipsis">
                        {{ pickup.SecurityGateFee | currency: 'USD' }}
                    </td>
                    <td class="ellipsis">
                        {{ totalPickupPrePayment(pickup) | currency: 'USD' }}
                    </td>
                    <td class="ellipsis">
                        {{ totalRemainingBalance(pickup) | currency: 'USD' }}
                    </td>
                    <td class="actions-cell">
                        <div class="actions-icon-group">
                            <button *ngIf="showConfirmButton(pickup)" (click)="confirmPickup(pickup)" class="btn btn-success btn-sm">Confirm</button>
                            <button *ngIf="showEditButton(pickup)" (click)="editPickup(pickup)" class="btn btn-info btn-sm">Edit</button>
                            <button
                                *ngIf="isCarrierUser && showPrePayButtons.get(pickup.Id)"
                                (click)="prePayPickup(pickup)"
                                class="btn btn-default btn-sm"
                            >
                                Pre-Pay
                            </button>
                            <button (click)="cancelPickup(pickup)" class="btn btn-danger btn-sm">Cancel</button>
                        </div>
                    </td>
                </tr>
                <tr class="no-pointer no-border order-row">
                    <th class="ellipsis sub-item-header">
                        <b>Order Number</b>
                    </th>
                    <th class="ellipsis sub-item-header">
                        <b>Office</b>
                    </th>
                    <th class="ellipsis sub-item-header">
                        <b>Warehouse</b>
                    </th>
                    <th *ngIf="isAdminUser || isCarrierUser" class="ellipsis sub-item-header">
                        <b>Customer</b>
                    </th>
                    <th *ngIf="isAdminUser || isCustomerUser" class="ellipsis sub-item-header"></th>
                    <th class="ellipsis sub-item-header"></th>
                    <th class="ellipsis sub-item-header">
                        <b>Pallet Count</b>
                    </th>
                    <th class="ellipsis sub-item-header">
                        <b>Order Weight</b>
                    </th>
                    <th class="ellipsis sub-item-header"></th>
                    <th class="ellipsis sub-item-header"></th>
                    <th class="ellipsis sub-item-header"></th>
                    <th class="ellipsis sub-item-header"></th>
                </tr>
                <tr *ngFor="let order of pickup.Orders" class="no-pointer no-border order-row">
                    <td class="ellipsis sub-item">
                        {{ order.OrderNumber }}
                    </td>
                    <td class="ellipsis sub-item">
                        {{ order?.Warehouse?.OfficeTitle ?? '' }}
                    </td>
                    <td *ngIf="order?.Warehouse?.WarehouseId" class="ellipsis sub-item">
                        {{ order?.Warehouse?.WarehouseId }}
                    </td>
                    <td *ngIf="!order?.Warehouse?.WarehouseId" class="ellipsis sub-item">
                        <mt-type-ahead
                            #warehouseTypeaheadControl
                            *ngIf="isAdminUser"
                            [items]="warehouses"
                            [maxToShow]="maxToShow"
                            (selectionChanged)="onWarehouseSelected($event, order, pickup)"
                            nameProperty="WarehouseId"
                        >
                        </mt-type-ahead>
                    </td>
                    <td *ngIf="isAdminUser || isCarrierUser" class="ellipsis sub-item">
                        {{ order?.CustomerName ?? '' }}
                    </td>
                    <td *ngIf="isAdminUser || isCustomerUser" class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>

                    <td *ngIf="isAdminUser" class="ellipsis sub-item">
                        <a (click)="updateOrderTotalPallet(order)" class="update-order-link">
                            {{ order.TotalPallet ?? 0 }}
                        </a>
                    </td>
                    <td *ngIf="!isAdminUser" class="ellipsis sub-item">
                        {{ order.TotalPallet ?? 0 }}
                    </td>
                    <td *ngIf="isAdminUser" class="ellipsis sub-item">
                        <a (click)="updateOrderTotalWeight(order)" class="update-order-link"> {{ order.TotalWeight?.toFixed(2) ?? '0.00' }} lbs </a>
                    </td>
                    <td *ngIf="!isAdminUser" class="ellipsis sub-item">{{ order.TotalWeight?.toFixed(2) ?? '0.00' }} lbs</td>
                    <td class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                </tr>
                <tr *ngIf="pickup.Orders.length <= 0" class="no-pointer no-border order-row">
                    <td class="ellipsis sub-item">N/A</td>
                    <td class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                    <td *ngIf="isAdminUser || isCarrierUser" class="ellipsis sub-item"></td>
                    <td *ngIf="isAdminUser || isCustomerUser" class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                    <td class="ellipsis sub-item"></td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>

<mt-modal-wrapper
    [showActions]="false"
    [autoShow]="false"
    [options]="{ width: 500, showCloseButton: true }"
    (ready)="orderTotalPalletDialogApi = $event"
>
    <order-total-pallet-dialog *ngIf="selectedOrder" [order]="selectedOrder" (onClose)="closeOrderTotalPalletDialog()"></order-total-pallet-dialog>
</mt-modal-wrapper>

<mt-modal-wrapper
    [showActions]="false"
    [autoShow]="false"
    [options]="{ width: 500, showCloseButton: true }"
    (ready)="orderTotalWeightDialogApi = $event"
>
    <order-total-weight-dialog *ngIf="selectedOrder" [order]="selectedOrder" (onClose)="closeOrderTotalWeightDialog()"></order-total-weight-dialog>
</mt-modal-wrapper>
